import _defineProperty from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { ValueState } from "../state";
import { StatefulAccessor } from "./StatefulAccessor";
import { Utils } from "../support";

var find = require("lodash/find");

var head = require("lodash/head");

var map = require("lodash/map");

export var SortingAccessor =
/*#__PURE__*/
function (_StatefulAccessor) {
  _inherits(SortingAccessor, _StatefulAccessor);

  function SortingAccessor(key, options) {
    var _this;

    _classCallCheck(this, SortingAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SortingAccessor).call(this, key));
    _this.state = new ValueState();
    _this.options = options;
    _this.options.options = Utils.computeOptionKeys(_this.options.options, ["field", "order"], "none");
    return _this;
  }

  _createClass(SortingAccessor, [{
    key: "getSelectedOption",
    value: function getSelectedOption() {
      var options = this.options.options;
      return find(options, {
        key: "".concat(this.state.getValue())
      }) || find(options, {
        defaultOption: true
      }) || head(options);
    }
  }, {
    key: "getSortQuery",
    value: function getSortQuery(sortOption) {
      if (sortOption.fields) {
        return map(sortOption.fields, function (field) {
          return _defineProperty({}, field.field, field.options || {});
        });
      } else if (sortOption.field && sortOption.order) {
        return [_defineProperty({}, sortOption.field, sortOption.order)];
      } else if (sortOption.field) {
        return [sortOption.field];
      }

      return null;
    }
  }, {
    key: "buildOwnQuery",
    value: function buildOwnQuery(query) {
      var selectedSortOption = this.getSelectedOption();

      if (selectedSortOption) {
        var sortQuery = this.getSortQuery(selectedSortOption);

        if (sortQuery) {
          query = query.setSort(sortQuery);
        }
      }

      return query;
    }
  }]);

  return SortingAccessor;
}(StatefulAccessor);